/**
 * @module support/ingenico
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Injectable } from '@angular/core';
import { OrderSearchResults } from '@experience/repdash/interfaces/order-profile.interface';

/**
 * Void Repdash store utils Service
 * @access public
 */
@Injectable()
export class VoidRepdashStoreUtilsService {
  constructor() {}

  /**
   * Function to get rep dash order lookup response
   * @param {string} keyName
   * @returns OrderSearchResults
   */
  public getRepdashStoreOrderLookupData(keyName: string): OrderSearchResults[] {
    return null;
  }
}
